import React, { useState } from 'react';
import DecorationSpecs from 'src/pages/editor/components/scene/product/decorationSpecs';

/**
 * Collapsible drawer displaying apparel decoration specifications and sizing data,
 * docked next to the canvas as a sibling of the tabbed side panel so it remains accessible
 * across tabs.
 *
 * Open/closed state is maintained in local component state. Defaults to collapsed to avoid
 * reducing canvas space for non-apparel products or before product selections have loaded.
 */
export default function DecorationSpecsDrawer() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
            className={`decoration-specs-drawer ${
                isOpen ? 'decoration-specs-drawer--open' : 'decoration-specs-drawer--collapsed'
            }`}
            data-testid='decoration-specs-drawer'>
            <button
                type='button'
                className='decoration-specs-drawer__toggle'
                onClick={() => setIsOpen(!isOpen)}
                aria-label={isOpen ? 'Collapse decoration specs panel' : 'Expand decoration specs panel'}
                aria-expanded={isOpen}>
                {isOpen ? '›' : '‹'}
                {!isOpen && <span className='decoration-specs-drawer__collapsed-label'>Decoration Specs</span>}
            </button>
            {isOpen && (
                <div className='decoration-specs-drawer__content'>
                    <h3 className='decoration-specs-drawer__title'>Apparel Decoration Specs</h3>
                    <DecorationSpecs />
                </div>
            )}
        </div>
    );
}
